if (!customElements.get('halloween-product-carousel')) {
  class HalloweenProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
      this.carouselMode = null;
      this.mediaQuery = null;
      this.runtimeFrame = null;
      this.handleMediaChange = this.syncCarousel.bind(this);
    }

    connectedCallback() {
      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      this.mediaQuery.addEventListener('change', this.handleMediaChange);
      this.syncCarousel();
    }

    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.handleMediaChange);
      this.cancelRuntimeRetry();
      this.destroyCarousel();
    }

    syncCarousel() {
      const desktop = this.mediaQuery?.matches;
      if (this.carousel && this.carouselMode !== desktop) this.destroyCarousel();
      this.initCarousel();
      if (!this.carousel) this.queueRuntimeRetry();
    }

    queueRuntimeRetry() {
      if (this.runtimeFrame !== null) return;

      this.runtimeFrame = window.requestAnimationFrame(() => {
        this.runtimeFrame = null;
        this.syncCarousel();
      });
    }

    cancelRuntimeRetry() {
      if (this.runtimeFrame === null) return;

      window.cancelAnimationFrame(this.runtimeFrame);
      this.runtimeFrame = null;
    }

    initCarousel() {
      if (this.carousel || !window.FoxTheme?.Carousel || !window.FoxTheme?.Swiper) return;

      const viewport = this.querySelector('[data-halloween-products-viewport]');
      const nextEl = this.querySelector('[data-halloween-products-next]');
      const prevEl = this.querySelector('[data-halloween-products-previous]');
      const pagination = this.querySelector('[data-halloween-products-pagination]');

      if (!viewport || !nextEl || !prevEl || !pagination) return;

      const desktop = this.mediaQuery?.matches;
      const options = desktop ? {
        modules: [window.FoxTheme.Swiper.Navigation, window.FoxTheme.Swiper.Pagination],
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 24,
        navigation: { nextEl, prevEl },
        pagination: { el: pagination, clickable: true },
        createElements: false,
        loop: false,
        threshold: 2,
      } : {
        modules: [window.FoxTheme.Swiper.Navigation, window.FoxTheme.Swiper.Pagination],
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 12,
        centeredSlides: false,
        navigation: { nextEl, prevEl },
        pagination: { el: pagination, clickable: true },
        createElements: false,
        loop: false,
        threshold: 2,
      };

      this.carousel = new window.FoxTheme.Carousel(viewport, options);
      this.carousel.init();
      this.carouselMode = desktop;
      this.cancelRuntimeRetry();
    }

    destroyCarousel() {
      if (!this.carousel) return;

      this.carousel.slider?.destroy(true, true);
      this.carousel = null;
      this.carouselMode = null;
    }
  }

  customElements.define('halloween-product-carousel', HalloweenProductCarousel);
}
